import { of } from "rxjs";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppState } from "../app.state";
import { Injectable } from "@angular/core";
import * as actions from "./actions";
import { BootstrapAlertService } from "../../widgets/ng-bootstrap-alert/bootstrap-alert.service";
import { NewsService } from "../../services/news.service";
import { DashboardService } from "../../services/dashboard.service";
import { BootstrapAlert } from "../../widgets/ng-bootstrap-alert/bootstrap-alert";
import { switchMap, catchError, map } from "rxjs/operators";

@Injectable()
export class NewsEffects {
  constructor(
    protected store: Store<AppState>,
    protected newsService: NewsService,
    protected rssService: DashboardService,
    protected action$: Actions,
    protected alertService: BootstrapAlertService,
  ) {}

  getNews$ = createEffect(() =>
    this.action$.pipe(
      ofType(actions.GET_NEWS),
      switchMap((action: actions.GetNewsAction) => {
        if (action.all && !action.published) {
          return this.newsService.getAllNews(action.url).pipe(
            map((result) => new actions.GetNewsSuccessAction(result)),
            catchError((error) => {
              this.alertService.alert(
                new BootstrapAlert("News error", "alert-danger"),
              );
              return of(new actions.GetNewsErrorAction(error));
            }),
          );
        } else {
          return this.newsService.getPublishedNews(action.url).pipe(
            map((result) => new actions.GetNewsSuccessAction(result)),
            catchError((error) => {
              this.alertService.alert(
                new BootstrapAlert("News error", "alert-danger"),
              );
              return of(new actions.GetNewsErrorAction(error));
            }),
          );
        }
      }),
    ),
  );

  getNewsById$ = createEffect(() =>
    this.action$.pipe(
      ofType(actions.GET_NEWS_BY_ID),
      switchMap((action: actions.GetNewsByIdAction) =>
        this.newsService.getNewsById(action.id, action.published).pipe(
          map((result) => new actions.GetNewsByIdSuccessAction(result)),
          catchError((error) => of(new actions.GetNewsErrorAction(error))),
        ),
      ),
    ),
  );
}
